export class OrderLiveBranchEntity {
  id?: number
  name?: string | null
  locationName?: string | null
  locationAddressDescription?: string | null
  brandImageUrl?: string | null
}
